import { gettext } from '@eventbrite/i18n';

export const FREE = gettext('Free');
export const UNLIMITED = gettext('Unlimited');

export const PRICE_PER_FREE_TICKET = {
    title: gettext('Fee per free ticket'),
    perPlanData: [FREE, FREE, FREE],
};

// perPlanData will be added at render time
export const PAYMENT_PROCESSING = {
    title: gettext('Payment processing'),
    link: '/support/articleredirect?anum=4373',
};

// remove when OPS-15787 is done
export const PAYMENT_PROCESSING_FR_CA = {
    title: gettext('Payment processing'),
    link: '/support/articleredirect?anum=4373&lg=fr_CA',
};

// remove when OPS-15787 is done
// we don't have a dedicated help center.
export const PAYMENT_PROCESSING_FR_BE = {
    title: gettext('Payment processing'),
    link: '/support/articleredirect?anum=4373&lg=fr_FR',
};

export const PAYMENT_PROCESSING_US_UK_CA_AU = {
    title: gettext('Payment processing'),
    link: '/l/eventbrite-payment-processing',
};

// Feature export constants
export const TICKET_TYPES = {
    title: gettext('Ticket types (e.g. "Early Bird")'),
    link: '/support/articleredirect?anum=3290',
    perPlanData: ['1', UNLIMITED, UNLIMITED],
};

export const TICKET_TYPES_AU = {
    title: gettext('Ticket types (e.g. "Early Bird")'),
    link: '/support/articleredirect?anum=3290',
    perPlanData: [UNLIMITED, UNLIMITED, UNLIMITED],
};

// remove when OPS-15787 is done
export const TICKET_TYPES_FR_CA = {
    title: gettext('Ticket types (e.g. "Early Bird")'),
    link: '/support/articleredirect?anum=3290&lg=fr_CA',
    perPlanData: ['1', UNLIMITED, UNLIMITED],
};

// remove when OPS-15787 is done
// we don't have a dedicated help center.
export const TICKET_TYPES_FR_BE = {
    title: gettext('Ticket types (e.g. "Early Bird")'),
    link: '/support/articleredirect?anum=3290&lg=fr_FR',
    perPlanData: ['1', UNLIMITED, UNLIMITED],
};

export const PUBLIC_EVENTS = {
    title: gettext('Public event listings'),
    perPlanData: [true, true, true],
};

export const PRIVATE_EVENTS = {
    title: gettext('Private (unlisted) events'),
    perPlanData: [true, true, true],
};

export const UNLIMITED_EVENTS = {
    title: gettext('Unlimited events'),
    perPlanData: [true, true, true],
};

export const STANDARD_CHECKOUT_FORM = {
    title: gettext('Standard checkout form'),
    perPlanData: [true, true, true],
};

export const DIGITAL_TICKETS = {
    title: gettext('Digital or printed tickets'),
    perPlanData: [true, true, true],
};

export const MOBILE_TICKETS = {
    title: gettext('Mobile tickets'),
    perPlanData: [true, true, true],
};

export const DONATION_COLLECTION = {
    title: gettext('Donation tickets'),
    perPlanData: [true, true, true],
};

export const PASS_ON_FEES = {
    title: gettext('Ability to pass online ticket fees to attendees'),
    perPlanData: [true, true, true],
};

export const FUNDRAISING_INTEGRATIONS = {
    title: gettext('Fundraising integrations'),
    perPlanData: [true, true, true],
};

export const RECURRING_EVENTS = {
    title: gettext('One listing for multiple recurring events'),
    perPlanData: [true, true, true],
};

export const CUSTOM_URL = {
    title: gettext('Custom URL'),
    perPlanData: [true, true, true],
};

export const WAITLISTS = {
    title: gettext('Waitlists'),
    perPlanData: [true, true, true],
};

export const AT_THE_DOOR_SALES = {
    title: gettext('At-the-door sales via app'),
    link: '/l/organizer-check-in-app/',
    perPlanData: [true, true, true],
};

export const CUSTOMIZABLE_ATTENDEE_INFO = {
    title: gettext('Customizable attendee info collection'),
    perPlanData: [false, true, true],
};

export const CUSTOMIZABLE_ORDER_CONFIRMATION = {
    title: gettext('Customizable order confirmation message'),
    perPlanData: [true, true, true],
};

export const RESERVED_SEATING = {
    title: gettext('Reserved seating'),
    link: '/support/articleredirect?anum=3212',
    perPlanData: [false, true, true],
};

// remove when OPS-15787 is done
export const RESERVED_SEATING_FR_CA = {
    title: gettext('Reserved seating'),
    link: '/support/articleredirect?anum=3212&lg=fr_CA',
    perPlanData: [false, true, true],
};

// remove when OPS-15787 is done
// we don't have a dedicated help center.
export const RESERVED_SEATING_FR_BE = {
    title: gettext('Reserved seating'),
    link: '/support/articleredirect?anum=3212&lg=fr_FR',
    perPlanData: [false, true, true],
};

export const RESERVED_SEATING_LANDING_PAGE = {
    title: gettext('Reserved seating'),
    link: '/l/reserved-seating/',
    perPlanData: [false, true, true],
};

export const REGISTRATION_TRANSFERS = {
    title: gettext('Registration transfers'),
    perPlanData: [false, true, true],
};

export const GROUP_REGISTRATION = {
    title: gettext('Group registration'),
    perPlanData: [false, true, true],
};

export const PRODUCT_TRAINING = {
    title: gettext('Product training'),
    perPlanData: [false, false, true],
};

export const MOBILE_OPTIMIZED_PURCHASE_FLOW = {
    title: gettext('100% mobile-optimized purchase flow'),
    perPlanData: [true, true, true],
};

export const PUBLIC_LISTINGS = {
    title: gettext('Public listing on Eventbrite & our consumer app'),
    perPlanData: [true, true, true],
};

export const INDUSTRY_LEADING_SEARCH = {
    title: gettext('Industry-leading search engine optimization'),
    perPlanData: [true, true, true],
};

export const AUTOMATED_SOCIAL_NOTIFICATIONS = {
    title: gettext('Automated social notifications'),
    perPlanData: [true, true, true],
};

export const ATTENDEE_SHARING_TOOLS = {
    title: gettext('Attendee social sharing tools'),
    perPlanData: [true, true, true],
};

export const ABANDONED_ORDER_EMAILS = {
    title: gettext('Abandoned order emails'),
    perPlanData: [true, true, true],
};

export const PARTNER_DISTRIBUTION = {
    title: gettext('Distribution to partner websites'),
    perPlanData: [true, true, true],
};

export const PARTNER_DISTRIBUTION_AU = {
    title: gettext('Distribution to partner websites'),
    perPlanData: [false, true, true],
};

export const PARTNER_DISTRIBUTION_US = {
    title: gettext('Distribution to partner websites'),
    link: '/l/post-events/',
    perPlanData: [true, true, true],
};

export const TICKETS_ON_FACEBOOK = {
    title: gettext('Ticket sales on Facebook'),
    perPlanData: [true, true, true],
};

export const TICKETS_ON_FACEBOOK_US = {
    title: gettext('Ticket sales on Facebook'),
    link: '/blog/boost-sales-by-selling-tickets-on-facebook-ds0d/',
    perPlanData: [true, true, true],
};

export const EMAIL_INVITATIONS = {
    title: gettext('Email invitations'),
    perPlanData: [true, true, true],
};

export const DISCOUNT_AND_ACCESS_CODES = {
    title: gettext('Discount and access codes'),
    perPlanData: [true, true, true],
};

export const MARKETING_INTEGRATIONS = {
    title: gettext('Email marketing, CRM, and paid advertising integrations'),
    perPlanData: [true, true, true],
};

export const SELL_ON_YOUR_WEBSITE = {
    title: gettext('Sell on your website'),
    perPlanData: [false, true, true],
};

export const BRANDED_IMG_ON_TICKETS = {
    title: gettext('Branded image on PDF tickets'),
    perPlanData: [false, false, true],
};

export const INSTALLMENT_PAYMENTS = {
    title: gettext('Installment payments'),
    perPlanData: [false, false, true],
};

export const INSTALLMENT_PAYMENTS_LATAM = {
    title: gettext('Installment payments (LATAM)'),
    perPlanData: [true, true, true],
};

export const COMMUNITY_PAGES = {
    title: gettext('Custom branded Community pages'),
    perPlanData: [false, false, true],
};

export const COMMUNITY_PAGES_LANDING_PAGE = {
    title: gettext('Custom branded Community pages'),
    link: '/l/eventbrite-communities/',
    perPlanData: [false, false, true],
};

export const SALES_RSVP_DASHBOARD = {
    title: gettext('Sales/RSVP summary dashboard'),
    perPlanData: [true, true, true],
};

export const DETAILED_EXPORTS = {
    title: gettext('Detailed exports of all data'),
    perPlanData: [true, true, true],
};

export const MOBILE_ORGANIZER_APP = {
    title: gettext('iOS and Android Organizer mobile app'),
    link: '/l/organizer-check-in-app/',
    perPlanData: [true, true, true],
};

export const GOOGLE_ANALYTICS_INTEGRATION = {
    title: gettext('Google Analytics integration'),
    perPlanData: [true, true, true],
};

export const SURVEY_INTEGRATIONS = {
    title: gettext('Survey integrations'),
    perPlanData: [true, true, true],
};

export const CROSS_EVENT_ANALYTICS = {
    title: gettext('Detailed cross-event analytics'),
    perPlanData: [false, true, true],
};

export const ANALYTICS_BY_TICKET_TYPE = {
    title: gettext('Detailed analytics by ticket type'),
    perPlanData: [false, true, true],
};

export const SELF_SERVICE_TRACKING_PIXELS = {
    title: gettext('Self-service tracking pixels'),
    perPlanData: [true, true, true],
};

export const TICKET_SCANNING_VIA_APP = {
    title: gettext('Ticket scanning via app'),
    link: '/l/organizer-check-in-app/',
    perPlanData: [true, true, true],
};

export const TICKET_SCANNING_VIA_APP_BR = {
    title: gettext('Ticket scanning via app'),
    link: '/l/check-in/',
    perPlanData: [true, true, true],
};

export const ATTENDEE_CHECK_IN_VIA_APP = {
    title: gettext('Attendee check-in via app'),
    link: '/l/organizer-check-in-app/',
    perPlanData: [true, true, true],
};

export const OPEN_API = {
    title: gettext('Access to open API'),
    perPlanData: [true, true, true],
};

export const BADGE_PRINTING_INTEGRATIONS = {
    title: gettext('Badge printing integrations'),
    perPlanData: [true, true, true],
};

export const BADGE_PRINTING_INTEGRATIONS_BR = {
    title: gettext('Badge printing integrations'),
    perPlanData: [false, false, true],
};

export const SESSION_MANAGEMENT_INTEGRATIONS = {
    title: gettext('Session management integrations'),
    perPlanData: [true, true, true],
};

export const SESSION_MANAGEMENT_INTEGRATIONS_BR = {
    title: gettext('Session management integrations'),
    perPlanData: [false, false, true],
};

export const ON_SITE_APP_INTEGRATIONS = {
    title: gettext('On-site attendee app integrations'),
    perPlanData: [true, true, true],
};

export const ON_SITE_APP_INTEGRATIONS_BR = {
    title: gettext('On-site attendee app integrations'),
    perPlanData: [false, false, true],
};

export const ON_SITE_CONSULTATION = {
    title: gettext('On-site consultation & support'),
    perPlanData: [false, false, true],
};

export const ON_SITE_CONSULTATION_LANDING_PAGE = {
    title: gettext('On-site consultation & support'),
    perPlanData: [false, false, true],
};

export const ON_SITE_STAFFING = {
    title: gettext('On-site staffing services'),
    perPlanData: [false, false, true],
};

export const ON_SITE_STAFFING_LANDING_PAGE = {
    title: gettext('On-site staffing services'),
    perPlanData: [false, false, true],
};

export const RENTAL_EQUIPMENT = {
    title: gettext('Rental equipment for box office and entry'),
    perPlanData: [false, false, true],
};

export const RENTAL_EQUIPMENT_LANDING_PAGE = {
    title: gettext('Rental equipment for box office and entry'),
    perPlanData: [false, false, true],
};

export const TEAM_ACCESS_AND_PERMISSIONS = {
    title: gettext('Team access and permissions'),
    perPlanData: [false, true, true],
};

export const TEAM_ACCESS_AND_PERMISSIONS_BR = {
    title: gettext('Team access and permissions'),
    perPlanData: [true, true, true],
};

export const EVENTBRITE_VENUE = {
    title: gettext('Eventbrite Venue'),
    link: '/l/music-venues/',
    perPlanData: [false, false, true],
};

export const ALL_MAJOR_CREDIT_CARDS = {
    title: gettext('Accepts all major credit cards'),
    perPlanData: [true, true, true],
};

export const PCI_COMPLIANT = {
    title: gettext('PCI-DSS 3.2 Level 1 compliance'),
    perPlanData: [true, true, true],
};

export const DIRECT_DEPOSIT_OR_CHECK = {
    title: gettext('Payout by direct deposit or check'),
    perPlanData: [true, true, true],
};

export const SECURE_PAYMENT_PROCESSING = {
    title: gettext('Secure payment processing'),
    perPlanData: [true, true, true],
};

export const ON_DEMAND_PAYOUTS = {
    title: gettext('Get paid out on demand'),
    perPlanData: [true, true, true],
};

export const SCHEDULED_PAYOUTS_TEXT = gettext('Scheduled Payouts');

export const SCHEDULED_PAYOUTS = {
    title: SCHEDULED_PAYOUTS_TEXT,
    perPlanData: [false, true, true],
};

export const EARLY_PAYOUTS = {
    title: gettext('Get payouts before your event'),
    link: '/support/articleredirect?anum=39028',
    perPlanData: [false, true, true],
};

// remove when OPS-15787 is done
export const EARLY_PAYOUTS_FR_CA = {
    title: gettext('Get payouts before your event'),
    link: '/support/articleredirect?anum=39028&lg=fr_CA',
    perPlanData: [false, true, true],
};

// remove when OPS-15787 is done
// we don't have a dedicated help center.
export const EARLY_PAYOUTS_FR_BE = {
    title: gettext('Get payouts before your event'),
    link: '/support/articleredirect?anum=39028&lg=fr_FR',
    perPlanData: [false, true, true],
};

export const CUSTOM_PAYOUT_SCHEDULE = {
    title: gettext('Custom payout schedule'),
    perPlanData: [false, false, true],
};

export const CHAT_SUPPORT_FR_CH = {
    title: gettext('Chat support during business hours'),
    perPlanData: [false, true, true],
};

export const PHONE_SUPPORT_CH = {
    title: gettext('Telephone support around the clock'),
    perPlanData: [false, true, true],
};

export const BUSINESS_HOUR_PHONE_SUPPORT_NZ_HK_SG = {
    title: gettext('Business hour phone support M-F'),
    perPlanData: [false, false, true],
};

export const CUSTOMER_SUCCESS_MANAGER = {
    title: gettext('Customer Success Manager'),
    perPlanData: [false, false, true],
};

export const START_SELLING_WITH_LANDING_PAGES = [
    TICKET_TYPES,
    PUBLIC_EVENTS,
    PRIVATE_EVENTS,
    UNLIMITED_EVENTS,
    STANDARD_CHECKOUT_FORM,
    DIGITAL_TICKETS,
    MOBILE_TICKETS,
    DONATION_COLLECTION,
    PASS_ON_FEES,
    FUNDRAISING_INTEGRATIONS,
    RECURRING_EVENTS,
    CUSTOM_URL,
    WAITLISTS,
    AT_THE_DOOR_SALES,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    RESERVED_SEATING_LANDING_PAGE,
    REGISTRATION_TRANSFERS,
    GROUP_REGISTRATION,
];

export const START_SELLING_WITH_LANDING_PAGES_AU = [
    TICKET_TYPES_AU,
    PUBLIC_EVENTS,
    PRIVATE_EVENTS,
    UNLIMITED_EVENTS,
    STANDARD_CHECKOUT_FORM,
    DIGITAL_TICKETS,
    MOBILE_TICKETS,
    DONATION_COLLECTION,
    PASS_ON_FEES,
    FUNDRAISING_INTEGRATIONS,
    RECURRING_EVENTS,
    CUSTOM_URL,
    WAITLISTS,
    AT_THE_DOOR_SALES,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    RESERVED_SEATING_LANDING_PAGE,
    REGISTRATION_TRANSFERS,
    GROUP_REGISTRATION,
];

export const START_SELLING_WITHOUT_FUNDRAISING = [
    TICKET_TYPES,
    PUBLIC_EVENTS,
    PRIVATE_EVENTS,
    UNLIMITED_EVENTS,
    STANDARD_CHECKOUT_FORM,
    DIGITAL_TICKETS,
    MOBILE_TICKETS,
    DONATION_COLLECTION,
    PASS_ON_FEES,
    RECURRING_EVENTS,
    CUSTOM_URL,
    WAITLISTS,
    AT_THE_DOOR_SALES,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    RESERVED_SEATING,
    REGISTRATION_TRANSFERS,
    GROUP_REGISTRATION,
];

export const START_SELLING_CL_CO_PE = [
    TICKET_TYPES,
    PUBLIC_EVENTS,
    PRIVATE_EVENTS,
    UNLIMITED_EVENTS,
    STANDARD_CHECKOUT_FORM,
    DIGITAL_TICKETS,
    MOBILE_TICKETS,
    DONATION_COLLECTION,
    PASS_ON_FEES,
    RECURRING_EVENTS,
    CUSTOM_URL,
    WAITLISTS,
    AT_THE_DOOR_SALES,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    REGISTRATION_TRANSFERS,
    GROUP_REGISTRATION,
];

export const START_SELLING_NORDICS = [
    TICKET_TYPES,
    PUBLIC_EVENTS,
    PRIVATE_EVENTS,
    UNLIMITED_EVENTS,
    STANDARD_CHECKOUT_FORM,
    DIGITAL_TICKETS,
    MOBILE_TICKETS,
    DONATION_COLLECTION,
    PASS_ON_FEES,
    FUNDRAISING_INTEGRATIONS,
    RECURRING_EVENTS,
    CUSTOM_URL,
    WAITLISTS,
    AT_THE_DOOR_SALES,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    RESERVED_SEATING_LANDING_PAGE,
    REGISTRATION_TRANSFERS,
    GROUP_REGISTRATION,
];

export const PROMOTE_AND_GROW_WITH_LANDING_PAGES = [
    MOBILE_OPTIMIZED_PURCHASE_FLOW,
    PUBLIC_LISTINGS,
    INDUSTRY_LEADING_SEARCH,
    AUTOMATED_SOCIAL_NOTIFICATIONS,
    ATTENDEE_SHARING_TOOLS,
    ABANDONED_ORDER_EMAILS,
    PARTNER_DISTRIBUTION,
    TICKETS_ON_FACEBOOK,
    EMAIL_INVITATIONS,
    DISCOUNT_AND_ACCESS_CODES,
    MARKETING_INTEGRATIONS,
    SELL_ON_YOUR_WEBSITE,
];

export const PROMOTE_AND_GROW_WITH_LANDING_PAGES_CH = [
    MOBILE_OPTIMIZED_PURCHASE_FLOW,
    PUBLIC_LISTINGS,
    INDUSTRY_LEADING_SEARCH,
    AUTOMATED_SOCIAL_NOTIFICATIONS,
    ATTENDEE_SHARING_TOOLS,
    ABANDONED_ORDER_EMAILS,
    PARTNER_DISTRIBUTION,
    EMAIL_INVITATIONS,
    DISCOUNT_AND_ACCESS_CODES,
    MARKETING_INTEGRATIONS,
];
